import { Box } from 'components/box';
import StickyMessage from 'components/sticky-message';
import { useMemo, useState } from 'react';
import { StickyMessageInterface } from 'types/types';
import StickyMessagesLoader from './sticky-messages-loader';
import { useRouter } from 'next/router';

const defaultMessageColor = 'lightBlue';
const checkoutMessageColor = 'lightOrange';

/**
 * NOTE: we load these messages from server-side for most pages,
 * but for the ones below there is no SSR, so we load them from client-side instead.
 */
const clientOnlyPages = ['/my-account', '/my-orders', '/checkout'];

const StickyMessages = ({
  messages,
}: {
  messages?: StickyMessageInterface[];
}) => {
  const { pathname } = useRouter();
  const isHomePage = pathname === '/';

  const shouldLoadOnClient = useMemo(() => clientOnlyPages.includes(pathname), [
    pathname,
  ]);

  const [stickyMessages, setStickyMessages] = useState<
    StickyMessageInterface[]
  >(messages || []);

  return (
    <>
      {stickyMessages.length > 0 && (
        <Box
          width="100%"
          backgroundColor={
            pathname === '/checkout'
              ? checkoutMessageColor
              : defaultMessageColor
          }
        >
          <StickyMessage
            messages={stickyMessages}
            path={pathname}
            isDismissible={isHomePage}
          />
        </Box>
      )}

      {shouldLoadOnClient && (
        <StickyMessagesLoader setStickyMessages={setStickyMessages} />
      )}
    </>
  );
};

export default StickyMessages;
